import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useStyles } from './SectionSubTitle_style'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

const SectionSubTitle = (props) => {
    const { titleId, descriptionId } = props
    const classes = useStyles()

    return (
        <Box className={classes.aboutPageBanner}>
            <Typography className={classes.title} variant='h2'>
                <FormattedMessage id={titleId} />
            </Typography>
            {descriptionId &&
                <Typography className={classes.description}>
                    <FormattedMessage id={descriptionId} />
                </Typography>
            }
        </Box>
    )
}

export default SectionSubTitle
